import { createReducer } from "redux-starter-kit";
import {
  startLoadingAction,
  loginSuccessAction,
  loginFailAction
} from "../actions/loginPage";

const INIT_STATE = {
  loginError: null,
  isLoading: false
};

const loginPage = createReducer(INIT_STATE, {
  [startLoadingAction]: (state, action) => {
    state.isLoading = true;
    state.loginError = null;
  },
  [loginSuccessAction]: (state, action) => {
    state.isLoading = false;
  },
  [loginFailAction]: (state, action) => {
    state.isLoading = false;
    state.loginError = action.payload.errMsg;
  }
});

export default loginPage;
